module.exports = __webpack_public_path__ + "img/logo-m2n.74aef16c.svg";